export default __webpack_public_path__ + "static/media/mahmoud.4d51a9a4.jpg";